var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-lg-8"},[_c('vue-page-transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('floating-back-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }